import { OrderWorkflowNode, TreatmentType } from 'app/core/enums';
import { StepBarNode } from '../step-bar';
import { Organizations } from 'app/core/constants';

export const ORDER_WORKFLOW_NODE_CONFIGS: StepBarNode[] = [
    {
        key: OrderWorkflowNode.SelectTeeth,
        title: 'general.selectTeeth',
        treatmentType: [TreatmentType.SmileDesign, TreatmentType.Veneers, TreatmentType.Moment],
        disableForOrganizations: [Organizations.neer.id],
    },
    {
        key: OrderWorkflowNode.SelectArch,
        title: 'general.selectArch',
        treatmentType: [TreatmentType.NightGuard],
    },
    {
        key: OrderWorkflowNode.DesignStyle,
        title: 'general.designStyle',
        treatmentType: [TreatmentType.SmileDesign, TreatmentType.Veneers, TreatmentType.Moment],
    },
    {
        key: OrderWorkflowNode.DesignStyle,
        title: 'general.guardType',
        treatmentType: [TreatmentType.NightGuard],
    },
    {
        key: OrderWorkflowNode.TreatmentInfo,
        title: 'general.treatmentInfo',
    },
    {
        key: OrderWorkflowNode.ReviewAndSubmit,
        title: 'general.reviewAndSubmit',
    },
];
